module.exports = __webpack_public_path__ + "img/horizontal-wally.a2590aa2.png";